import React from "react";
import { Container, Image, Header, Button } from "semantic-ui-react";
import InviteAcceptedImage from '../../../images/grafix-banner/gfx-invite-accepted.svg'
import { dispatch } from '@rematch/core';
import { push } from "react-router-redux";

class AlreadyInviteAccepted extends React.Component {
    goToLogin(e) {
        return dispatch(push('/login'));
    }
    render() {
        return (
            <Container fluid className="pad_40">
                <Image src={InviteAcceptedImage} size='medium' centered={true} />
                <Header as='h3' icon textAlign='center'>
                    <Header.Content>
                        <span className="clr-green"> The invitation has already been accepted </span>
                        <br />  <br />
                    </Header.Content>
                    <Header.Content className="clr-gray f_14" >
                        You can login to your account
                        <br /><br />
                    </Header.Content>
                    <Button className="button-submit" onClick={this.goToLogin}>Login</Button>
                </Header>
            </Container>
        );
    }
}
export default AlreadyInviteAccepted;
